import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import LinkedAccountErrorDetailsLayout
  from 'Views/Page/Content/Templates/LinkedAccountErrorViewTemplate/MainPanel/LinkedAccountErrorDetailsLayout';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});

const MainPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();
  function handleExpanded(resource) {
    return (
      <Card>
        <MetaFormInline
          resource={resource}
          layout={LinkedAccountErrorDetailsLayout}
          readonly
        />
      </Card>
    );
  }
  return (
    <MetaTable
      onExpanded={handleExpanded}
      className={classNames(className, classes.root)}
      classes={{ cell: classes.root }}
      collection={pageContentCollection}
      RowProps={{
        metaOverrideSet,
      }}
      columns={[
        { name: 'householdId', style: { minWidth: '60px' } },
        { name: 'source', style: { minWidth: '60px' } },
        { name: 'institutionName' },
        { name: 'institutionId' },
        { name: 'externalAccountId', style: { minWidth: '200px' } },
        { name: 'errorCode', style: { minWidth: '150px' } },
      ]}
    />
  );
};

MainPanel.defaultProps = {
  className: '',
};

MainPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPanel);
